<div
  id="uzd-protocol"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="ch_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Контури печінки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_konturs" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">збережені:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_zber" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Товщина правої долі:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_tov_prav_doli" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Товщина ліваї долі:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_tov_liv_doli" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Структура паренхіми:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="ch_parenhimu">
            <option value="однорідна">однорідна</option>
            <option value="неоднорідна">неоднорідна</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('ізоекогенна:', 'ch_exo')"> ізоекогенна </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('з ділянками гематозу', 'ch_exo')"> з ділянками гематозу </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ехогенність:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="ch_exo"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">V.Portae:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_v_portae" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Судинний малюнок:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_sud_mal" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Холєдох:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_holedoh" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('не поширені', 'two_results')"> не поширені </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('контуруються', 'two_results')"> контуруються </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Жовчні ходи:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="ch_zov_hodu"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <strong>Жовчний міхур</strong>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">розмірами:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_z_rozmir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">з наявністю перегиба:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="ch_z_perevib">
            <option value="так">так</option>
            <option value="ні">ні</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">товщина передньої стінки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_z_pered_stinka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">слиз по задній стінці:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="ch_z_sluz_po_zadniy">
            <option value="так">так</option>
            <option value="ні">ні</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Об'єм жовчного міхура:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_z_obyem" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Підшлункова залоза:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_zaloza" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Голівка:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_zaloza_golivka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Тіло:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_zaloza_tilo" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Хвіст:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_zaloza_hvist" />
        </clr-input-container>
      </div>
    </div>


    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Селезінка:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_zaloza_selezinka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Права нирка:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_p_nurka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">паренхіма:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_p_nurka_parenhima" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЧПК:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_p_nurka_chpk" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серединний сегмент:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_p_nurka_segment" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Порожниста система:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="ch_p_nurka_ps">
            <option value="поширена">поширена</option>
            <option value="непоширена">непоширена</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ліва нирка:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_l_nurka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">паренхіма:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_l_nurka_parenhima" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЧПК:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_l_nurka_chpk" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серединний сегмент:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_l_nurka_segment" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Порожниста система:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="ch_l_nurka_ps">
            <option value="поширена">поширена</option>
            <option value="непоширена">непоширена</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Сечовий міхур:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="ch_mihur" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки гематозу', 'ch_results')"> ознаки гематозу </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки хронічного холециститу', 'ch_results')"> ознаки хронічного холециститу </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки хронічного калькульозного холециститу', 'ch_results')"> ознаки хронічного калькульозного холециститу </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки хронічного некалькульозного холециститу', 'ch_results')"> ознаки хронічного некалькульозного холециститу </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки хронічного паткреатиту', 'ch_results')"> ознаки хронічного паткреатиту </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('дифузні зміни підшлункової залози', 'ch_results')"> дифузні зміни підшлункової залози </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('поліп жовчевого міхура', 'ch_results')"> поліп жовчевого міхура </button>
      </div>
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки солевого діатезу', 'ch_results')"> ознаки солевого діатезу </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки мієліту обох нирок без порушення масажу сечі', 'ch_results')"> ознаки мієліту обох нирок без порушення масажу сечі </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки мієліту обох нирок з порушенням масажу сечі зліва', 'ch_results')"> ознаки мієліту обох нирок з порушенням масажу сечі зліва </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки мієліту обох нирок з порушенням масажу сечі справа', 'ch_results')"> ознаки мієліту обох нирок з порушенням масажу сечі справа</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('правобічний гідронефроз', 'ch_results')"> правобічний гідронефроз</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('лівобічний гідронефроз', 'ch_results')"> лівобічний гідронефроз</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('правобічна піелоектазія', 'ch_results')"> правобічна піелоектазія</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('лівобічна піелоектазія', 'ch_results')"> лівобічна піелоектазія</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('кисти обох нирок', 'ch_results')"> кисти обох нирок</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('киста лівої нирки', 'ch_results')"> киста лівої нирки</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('киста правої нирки', 'ch_results')"> киста правої нирки</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки пієлонефриту справа', 'ch_results')"> ознаки пієлонефриту справа</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки пієлонефриту зліва', 'ch_results')"> ознаки пієлонефриту зліва</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки гідрокалікозу зліва', 'ch_results')"> ознаки гідрокалікозу зліва</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки гідрокалікозу справа', 'ch_results')"> ознаки гідрокалікозу справа</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЗАКЛЮЧЕННЯ:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="ch_results"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
